import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Email, EmailAttachment } from 'app/pechkin/test/services/email';
import { PechkinService } from 'app/pechkin/test/services/pechkin.service';
import { TemplateService } from 'app/mdm/template/services/template.service';
import { Template } from 'app/mdm/template/services/template';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '@heda/core-hospital-ui';

@Component({
  selector: 'hw-email-test',
  templateUrl: './email-test.component.html',
})
export class EmailTestComponent implements OnInit {
  email: Email = new Email();
  inputVisibleReceiver: boolean;
  inputVisibleAttachment: boolean;
  templates: Array<Template>;

  form: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private pechkinService: PechkinService,
    private messageService: MessageService,
    private templateService: TemplateService,
    private translateService: TranslateService
  ) {
    this.form = this.createForm(this.fb);
  }

  ngOnInit(): void {
    this.templateService.loadTemplates('email').subscribe((reps) => (this.templates = reps));
  }

  private createForm(fb: UntypedFormBuilder): UntypedFormGroup {
    return fb.group({
      receivers: [[], [Validators.required]],
      message: ['', [Validators.required]],
      subject: ['', [Validators.required]],
      attachment: [[]],
      newReceiver: [''],
      newAttachment: [''],
      template: [''],
    });
  }

  send(): void {
    const formDataValue = this.form.value;
    const email = Object.assign(this.email, {
      receivers: formDataValue.receivers,
      message: formDataValue.message,
      subject: formDataValue.subject,
      attachments: formDataValue.attachment,
    });
    this.pechkinService.sendEmail(email).subscribe(
      () => {
        this.messageService.success('pechkin.test-01.message.success');
      },
      (err) => {
        this.messageService.error('pechkin.test-01.message.error');
      }
    );
  }

  addReceiver() {
    const receivers = this.form.value.receivers;
    receivers.push(this.form.value.newReceiver);
    this.inputVisibleReceiver = false;
    this.form.patchValue({ newReceiver: null });
    this.form.patchValue({ receivers: receivers });
  }

  deleteReceiver(receiver: string) {
    let receivers = this.form.value.receivers;
    receivers = this.arrayRemove(receivers, receiver);
    this.form.patchValue({ receivers: receivers });
  }

  addAttachment() {
    const attachments = this.form.value.attachment;
    attachments.push({ url: this.form.value.newAttachment });
    this.inputVisibleAttachment = false;
    this.form.patchValue({ newAttachment: null });
    this.form.patchValue({ attachment: attachments });
  }

  removeAttachment(attachment: EmailAttachment) {
    let attachments = this.form.value.attachment;
    attachments = this.arrayRemove(attachments, attachment);
    this.form.patchValue({ attachment: attachments });
  }

  arrayRemove(arr, value) {
    return arr.filter((e) => e != value);
  }

  templateChange(value: Template): void {
    const language = this.translateService.currentLang;
    this.templateService
      .getTemplate(value.code)
      .subscribe((resp) => this.form.patchValue({ message: resp.content[language] }));
  }
}
